import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AltraParte } from 'src/app/common/models/altraparte';
import { Parte } from 'src/app/common/models/parte';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'step-soggetti-terzi-form',
  templateUrl: './step-soggetti-terzi-form.component.html',
  styleUrls: ['./step-soggetti-terzi-form.component.css']
})
export class StepSoggettiTerziFormComponent implements OnInit {

  currentForm: string;
  form = FORM;
  @Input() parte: Parte;
  @Output() altraParteChange: EventEmitter<AltraParte> = new EventEmitter<AltraParte>();
  @Output() onParteReturn: EventEmitter<Parte> = new EventEmitter<Parte>();

  constructor(
    private operations: OperationsService
  ){
  }

  ngOnInit() {
    this.currentForm = (this.parte != null) ? FORM.ASSOCIATIVA : FORM.ANAGRAFICA;
  }

  onEmitAnagrafica(parte: Parte){
    this.parte = parte;
    this.operations.addNewAnagrafica(parte).subscribe(
      response => this.onParteReturn.emit(response.anagrafiche[0] as Parte)
    );
    this.currentForm = FORM.ASSOCIATIVA;
  }

  onEmitAssociativa(event: AltraParte){
    this.altraParteChange.emit(event);
    this.currentForm = FORM.ANAGRAFICA;
  }

}

export enum FORM{
  ANAGRAFICA = 'anagrafica',
  ASSOCIATIVA = 'associativa'
}
